import type { Locale } from './types';

export type GuideLoaders = Record<Locale, (id: string) => Promise<unknown>>;

// Two literal contexts so webpack emits one lazy chunk group per locale.
const defaultLoaders: GuideLoaders = {
  'en-US': (id) =>
    import(/* webpackChunkName: "help-guide-en" */ `./content/en-US/${id}.md`),
  fr: (id) =>
    import(/* webpackChunkName: "help-guide-fr" */ `./content/fr/${id}.md`),
};

function unwrap(mod: unknown): string {
  if (typeof mod === 'string') return mod;
  const d = (mod as { default?: unknown })?.default;
  if (typeof d === 'string') return d;
  throw new Error('Guide module did not resolve to a string');
}

export function toContentLocale(language?: string | null): Locale {
  return (language ?? '').toLowerCase().startsWith('fr') ? 'fr' : 'en-US';
}

export async function loadGuide(
  locale: Locale,
  id: string,
  loaders: GuideLoaders = defaultLoaders
): Promise<string> {
  try {
    return unwrap(await loaders[locale](id));
  } catch (error) {
    if (locale !== 'en-US') return unwrap(await loaders['en-US'](id));
    throw error;
  }
}
